import walletTemplatePreviewModalCreator from '../../helpers/wallet-template-preview-modal-creator';
import walletTemplateModelReducer from '../../helpers/template-model-reducer';

class DownloadWalletTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.http = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.resourceSelect = this.injector.get('ResourceSelect');
        this.fileSaver = this.injector.get('FileSaver');
        this.translate = this.injector.get('$translate');

        this.key = 'download-passbook';
        this.title = this.translate.instant('wallets.templates.workflows.details.download');
        this.level = 'highlight';
        this.icon = 'upload';
    }

    action(walletTemplate, vm) {
        return walletTemplatePreviewModalCreator(this.injector, walletTemplateModelReducer(walletTemplate));
    }

}

angular
    .module('festzelt-os.modules.wallets.templates')
    .factory('downloadPassbook', [
        '$injector',
        ($injector) => new DownloadWalletTemplateWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/workflows/details/download.js